
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { setNotification } from "../../components/notification/ToastNotification";
import { message } from "../../utilities/locals/messages";
import { EMAIL_ALREADY_EXIST, MOBILE_ALREADY_EXIST } from "../../config/permissions";
import { addNursingStaffReg, addNursingStaffRegImage, removeNursingStaffRegImage } from "../../services/nursingStaffRegServices";

export interface NursingStaffRegistrationState {
    loading: 'idle' | 'loading' | 'success' | 'error'|'updatedSuccess';
    uploadedImg: string;
    imageId: number | null;
}

const initialState: NursingStaffRegistrationState = {
    loading: 'idle',
    uploadedImg: '',
    imageId: null,
}

export const nursingStaffRegistrationSlice = createSlice({
    name: "nursingStaffRegistrationSlice",
    initialState,
    reducers: {
        changeLoading: (state, action: PayloadAction<any>) => {
            state.loading = action.payload;
        },
        resetImage: (state) => {
            state.imageId=null;
            state.uploadedImg='';
        },
    },
    extraReducers: (builder) => {

        builder.addCase(addNursingStaffRegImage.pending, (state) => {
            state.uploadedImg = '';
            state.imageId = null;
            state.loading = 'idle';
        });

        builder.addCase(addNursingStaffRegImage.fulfilled, (state,action) => {
            state.uploadedImg = action.payload.profile_pic;
            state.imageId = action.payload.id;
            state.loading = 'updatedSuccess';
        });
        builder.addCase(addNursingStaffRegImage.rejected, (state) => {
            state.loading = 'error';
        });


        
        builder.addCase(removeNursingStaffRegImage.pending, (state) => {
            state.loading = 'idle';
        });

        builder.addCase(removeNursingStaffRegImage.fulfilled, (state) => {
            state.uploadedImg = '';
            state.imageId = null;
            state.loading = 'updatedSuccess';
        });
        builder.addCase(removeNursingStaffRegImage.rejected, (state) => {
            state.loading = 'error';
        });

        
        builder.addCase(addNursingStaffReg.pending, (state) => {
            state.loading = 'loading';
        });
        builder.addCase(addNursingStaffReg.fulfilled, (state) => {
            state.loading = 'success';

        });
        builder.addCase(addNursingStaffReg.rejected, (state, { payload }: any) => {
            state.loading = 'error';

            if (payload.response.data.error_message === EMAIL_ALREADY_EXIST) {
                setNotification(message.CFPCareConnect, message.emailExist, false, 'failed', 'addNursingStaffReg');
            } else if (payload.response.data.error_message === MOBILE_ALREADY_EXIST) {
                setNotification(message.CFPCareConnect, message.mobileNumberExist, false, 'failed', 'addNursingStaffReg');
            } else {
                setNotification(message.CFPCareConnect, message.userAddedfailed, false, 'failed', 'addNursingStaffReg');
            }

        });


    }
});

export const { changeLoading ,resetImage} = nursingStaffRegistrationSlice.actions;
export const NursingStaffRegistrationSlices = (state: RootState) => state.nursingStaffRegistrationData
export const nursingStaffRegistrationReducer = nursingStaffRegistrationSlice.reducer;